<template>
  <a-entity>
    <a-entity :key="'cloud' + index" ref="cloud_holder" v-for="(n, index) in clouds">
      <a-image
        width="180"
        height="180"
        material="shader: flat; fog: false"
        look-at=".Camera"
        :position="'0 50 -' + (start + 12 * n)"
        transparent="true"
        opacity="0"
        scale="0 0 0"
        ref="cloud"
        @materialtextureloaded="elLoaded"
        :src="cdn(require('./img/cloud' + n + '.png'))" />
    </a-entity>
  </a-entity>
</template>

<script>
export default {
  name: 'Clouds',
  data: () => ({
    elsLoaded: 0,
    start: 80,
    clouds: [1, 2, 3, 4, 5, 1, 2, 3, 4, 5, 1, 2]
  }),
  watch: {
    '$route': 'setColor',
  },
  methods: {
    setColor() {
      // TweenLite.to(this.$refs.cloud, 5, { aframe: { alpha: this.$route.params.captation ? .7 : 1 } })
      // if fog activated
      TweenLite.to(this.$refs.cloud, 5, { aframe: { alpha: this.$route.params.captation ? .7 : .4 } })
    },
    elLoaded(e) {
      this.elsLoaded++

      e.target.object3DMap.mesh.material.depthWrite = false

      if(this.elsLoaded == this.$refs.cloud_holder.length)
        this.loaded()
    },
    loaded() {
      TweenLite.set(this.$refs.cloud, { aframe: { scale: 1 } })
      TweenLite.to(this.$refs.cloud, 1, { aframe: { alpha: 1 } })
      this.setColor()
      _.each(this.$refs.cloud_holder, (cloud_holder, k) => {
        const r = k * 50
        const time = _.random(700, 900)
        TweenLite.set(this.$refs.cloud[k], { aframe: { y: _.random(50, 120) } })
        TweenMax.set(cloud_holder, { aframe: { rotationY: k * 50 }})
        TweenMax.to(cloud_holder, time, { aframe: { rotationY: r + 360 }, repeat: -1, ease: Linear.easeInOut })
      })
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/clouds/Clouds.vue